/**
 * @param {Phaser.Scene} scene
 */
export const createAnimation = (scene) => {
  let charFrames = [];
  for (let i = 0; i < 8; i++) {
    charFrames = [...charFrames, { key: `run${i}` }];
  }
  scene.anims.create({
    key: "run",
    frames: charFrames,
    frameRate: 13,
    repeat: -1,
  });
  let sCharFrames = [];
  for (let i = 0; i < 8; i++) {
    sCharFrames = [...sCharFrames, { key: `skinnedRun${i}` }];
  }
  scene.anims.create({
    key: "skinnedRun",
    frames: sCharFrames,
    frameRate: 13,
    repeat: -1,
  });

  scene.anims.create({
    key: "coin",
    frames: [
      { key: "coin0" },
      { key: "coin1" },
      { key: "coin2" },
      { key: "coin3" },
    ],
    frameRate: 7,
    repeat: -1,
  });
  scene.anims.create({
    key: "jump",
    frames: [
      { key: "jump0" },
      { key: "jump1" },
      { key: "jump2" },
      { key: "jump3" },
      { key: "jump4" },
    ],
    frameRate: 10,
    repeat: -1,
  });
  scene.anims.create({
    key: "skinnedJump",
    frames: [
      { key: "skinnedJump0" },
      { key: "skinnedJump1" },
      { key: "skinnedJump2" },
      { key: "skinnedJump3" },
    ],
    frameRate: 10,
    repeat: -1,
  });
  scene.anims.create({
    key: "slide",
    frames: [
      { key: "slide0" },
      { key: "slide1" },
      { key: "slide2" },
      { key: "slide3" },
    ],
    frameRate: 10,
    repeat: -1,
  });
  scene.anims.create({
    key: "skinnedSlide",
    frames: [
      { key: "skinnedSlide0" },
      { key: "skinnedSlide1" },
      { key: "skinnedSlide2" },
      { key: "skinnedSlide3" },
    ],
    frameRate: 10,
    repeat: -1,
  });
  scene.anims.create({
    key: "dizzy",
    frames: [{ key: "dizzy0" }, { key: "dizzy1" }, { key: "dizzy2" }],
    frameRate: 10,
    repeat: -1,
  });
  scene.anims.create({
    key: "skinnedDizzy",
    frames: [
      { key: "skinnedDizzy0" },
      { key: "skinnedDizzy1" },
      { key: "skinnedDizzy2" },
    ],
    frameRate: 10,
    repeat: -1,
  });
  scene.anims.create({
    key: "win",
    frames: [
      { key: "idle" },
      { key: "run0" },
      { key: "run0" },
      { key: "idle" },
    ],
    frameRate: 10,
    repeat: 6,
  });
  scene.anims.create({
    key: "skinnedWin",
    frames: [
      { key: "skinnedIdle" },
      { key: "skinnedJump0" },
      { key: "skinnedJump0" },
      { key: "skinnedIdle" },
    ],
    frameRate: 10,
    repeat: 6,
  });
  scene.anims.create({
    key: "chest",
    frames: [
      { key: "chestClosed" },
      { key: "chestCrack" },
      { key: "chestOpen" },
    ],
    frameRate: 5,
  });
  scene.anims.create({
    key: "poof",
    frameRate: 15,
    frames: [
      { key: "poof1" },
      { key: "poof2" },
      { key: "poof3" },
      { key: "poof4" },
    ],
    repeat: 0,
  });
};
